import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ApplicationRedirector from "./ApplicationRedirector";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import { SearchBar } from "src/chamber/features/dashboard/ui/SearchBar";
import { useState } from "react";

type TCertificateApplicationsProps = {
  isOrgAdmin: boolean;
  legalTypes: { d08_id: number; d08_descr: string }[];
  appTypes: { label: string; value: number }[];
  chamberUsers: { label: string; value: number }[];
  responsibleNow: { label: string; value: number }[];
  statuses: { label: string; value: number }[];
  activeOwnCertificateApplicationsCount: number | null;
  activeChamberCertificateApplicationsPaidCount: number | null;
  activeChamberCertificateApplicationsUnpaidCount: number | null;
  unsignedOwnCertificateApplicationsCount: number | null;
  countsLoading?: boolean;
};

function CertificateApplications(props: TCertificateApplicationsProps) {
  const { t } = useTranslation();
  const [protocol, setProtocol] = useState("");
  const [gemi, setGemi] = useState("");

  return (
    <Paper sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem",
        }}
      >
        <Typography
          variant="h5"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <TaskOutlinedIcon />
          {t("Αιτήσεις Πιστοποιητικών / Αντιγράφων")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <SearchBar
          mode={"certificate"}
          protocol={protocol}
          gemi={gemi}
          setProtocol={setProtocol}
          setGemi={setGemi}
        />
      </Box>
      <ApplicationRedirector
        countsLoading={props.countsLoading}
        useForCertificate={true}
        activeChamberCertificateApplicationsPaidCount={
          props.activeChamberCertificateApplicationsPaidCount
        }
        activeChamberCertificateApplicationsUnpaidCount={
          props.activeChamberCertificateApplicationsUnpaidCount
        }
        activeOwnCertificateApplicationsCount={
          props.activeOwnCertificateApplicationsCount
        }
        unsignedOwnCertificateApplicationsCount={props.unsignedOwnCertificateApplicationsCount}
        isOrgAdmin={props.isOrgAdmin}
        responsibleNow={props.responsibleNow}
        legalTypes={props.legalTypes}
        appTypes={props.appTypes}
        statuses={props.statuses}
        chamberUsers={props.chamberUsers}
      />
    </Paper>
  );
}

export default CertificateApplications;
